<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oXFW19/tc-custom/9781523093984.jpg?1702846311804" alt="This image is the cover for the book Servant Leadership in Action"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Servant Leadership in Action
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>The One-Minute Manager</i>, a guide to leading others by serving them, featuring advice and tools from real-life leadership experts.</b><br/><br/>We’ve all seen the negative impact of self-serving leaders in every sector of our society. Not infrequently, they end up bringing down their entire organization. But there is another way: servant leadership.<br/><br/>Servant leaders lead by serving their people, not by exalting themselves. This collection features forty-four renowned servant leadership experts and practitioners—prominent business executives, bestselling authors, and respected spiritual leaders—who offer advice and tools for implementing this proven, but for some still radical, leadership model.<br/><br/>Edited by legendary business author and lifelong servant leader Ken Blanchard and his longtime editor Renee Broadwell, this is the most comprehensive and wide-ranging guide ever published for what is, in every sense, a better way to lead.<br/><br/><b><i>“</i>Renowned expert Ken Blanchard with Renee Broadwell have assembled the insights of dozens of successful leaders in their new book <i>Servant Leadership In Action</i>. I doubt you will find any book or course on leadership that delivers a more on-target message of the essential element critical to being a truly great leader. Get a copy. Read it. Be it.” —<i>Miami Herald</i></b><br/><br/><b>“A comprehensive and inspiring book presented as a servant leadership primer, action plan and how-to guide, then concludes with proof of effectiveness and inspiration to go forward. The wide-ranging yet related topics covered in <i>Servant Leadership In Action</i> is part of what makes the book so valuable. I am sure it will quickly become a must-have resource for leaders, both emerging and established.<i>” —Being Fully Present</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ken Blanchard, Rene Broadwell, John C. Maxwell
      </h2>
      
      <p class="authorDescription body article">Ken Blanchard is the founder and chief spiritual officer of The Ken Blanchard Companies. He is the coauthor of several best-selling books, including The One Minute Manager®_and The New One Minute Manager®, Raving Fans and Gung Ho! His books have combined sales of more than twenty million copies in forty-two languages. Ken is also cofounder of Lead Like Jesus, a nonprofit organization dedicated to inspiring and equipping people to be servant leaders.</P><br/><br/><P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c471380